module.exports = __webpack_public_path__ + "img/log_light_4.398d84a5.png";